module.exports = __webpack_public_path__ + "static/media/algorandwallet.4d8883de.svg";